// react
import * as React from 'react';
import { ThreeDots  } from 'svg-loaders-react'

export default function Loading() {
  return (
    <div className="loading">
      <ThreeDots  />
    </div>
  );
}
